import { render, staticRenderFns } from "./imgupload.vue?vue&type=template&id=35fe193c&"
import script from "./imgupload.vue?vue&type=script&lang=js&"
export * from "./imgupload.vue?vue&type=script&lang=js&"
import style0 from "./imgupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports